import { useHistory } from 'react-router-dom';
export const useGoBack = () => {
    const history = useHistory();
    const goBack = () => {
        history.push('/files');
    };
    const reload = () => {
        window.location.reload();
    };
    return { goBack, reload };
};
